import authInstance from "../Interceptor/interceptor";

export const addStaffEffect = (staffData) => {
  return authInstance.post("/staffs/insert", staffData);
};

export const deleteStaffEffect = (id) => {
  return authInstance.delete(`/staffs/deletestaff/${id}`);
};

export const editStaffEffect = (id, formData) => {
  return authInstance.put(`/staffs/updatestaff/${id}`, formData);
};
export const ViewStaffEffect = (staffId) => {
  return authInstance.get(`/staffs/getstaff/?staff_id=${staffId}`);
};
export const listStaffEffect = (payload) => {
  const { pageNo, pagesize, pagination_required, search, search_by } = payload;
  return authInstance.get(
    `/staffs/list?pageNo=${pageNo}&pagesize=${pagesize}&pagination_required=${pagination_required}&search_by=${search_by}&search=${search}`
  );
};

export const historyStaffEffect = (pageNo) => {
  return authInstance.get(
    `/attenderbooking/getbysecirity?pageNo=${pageNo}&pagesize=10`
  );
};
